
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import displayINRCurrency from "../helpers/displayCurrency";
import OrderTimeline from "../components/OrderTimeline";

const OrderDetails = () => {

  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    fetchOrder();
  }, []);

  const fetchOrder = async () => {
    const res = await fetch(
      `https://lappyshop.onrender.com/api/order/${id}`,
      { credentials: "include" }
    );

    const data = await res.json();

    if (data.success) {
      setOrder(data.data);
    }
  };

  if (!order) return null;

  return (
    <div className="container mx-auto p-6">

      <h1 className="text-2xl font-semibold mb-6">
        Order Details
      </h1>

      <div className="bg-white rounded shadow p-6">

        {/* Order Info */}

        <div className="mb-4">
          <p className="text-gray-500 text-sm">Order ID</p>
          <p className="font-medium">{order._id}</p>
        </div>

        <div className="mb-4">
          <p className="text-gray-500 text-sm">Payment</p>
          <p>{order.paymentMethod} - {order.paymentStatus}</p>
        </div>

        {/* Order Timeline */}

        {order.orderStatus === "cancelled" ? (
          <div className="bg-red-100 text-red-600 p-4 rounded mb-4">
            This order has been cancelled
          </div>
        ) : (
          <OrderTimeline status={order.orderStatus} />
        )}

        {/* Products */}

        <div className="border-t pt-4 space-y-4 mt-6">

          {order.items.map((item) => (
            <div
              key={item._id}
              className="flex justify-between items-center"
            >

              <div>
                <p className="font-medium">
                  {item.productId.productName}
                </p>

                <p className="text-sm text-gray-500">
                  Qty: {item.quantity}
                </p>
              </div>

              <p className="font-semibold text-red-600">
                {displayINRCurrency(
                  item.quantity * item.price
                )}
              </p>

            </div>
          ))}

        </div>

        {/* Total */}

        <div className="border-t pt-4 mt-4 flex justify-between font-semibold text-lg">
          <span>Total</span>
          <span>
            {displayINRCurrency(order.totalAmount)}
          </span>
        </div>

      </div>

    </div>
  );
};

export default OrderDetails;